import { ComponentIds, } from "@inter-ikea-core/core";
import { getUprights } from "../utils/sectionsHelpers";
import { replaceEntity } from "./MountingRails";
import { MountingRailConnectionService, } from "../utils/ConnectorService";
import { getMountingRailIndexInSolution, indexMountingRailsInSolution, } from "../utils/mountingRailHelpers";
import { MOUNTING_RAIL_TO_UPRIGHT } from "../constants/connectorKeys";
import { getEntityProductRef } from "./MountingRails";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { ENTITY_DOESNT_EXIST_IN_COLOR, NO_UPRIGHTS } from "../constants/errors";
import { ENTITY_NOT_IN_CATALOG, NO_CONNECTION, } from "@inter-ikea-storagetwo/range/dist/constants/errors";
const areOfSameTypeAndSize = (p1, p2) => p1.type === p2.type &&
    p1.template.comSize.width === p2.template.comSize.width &&
    p1.template.comSize.depth === p2.template.comSize.depth &&
    p1.template.comSize.height === p2.template.comSize.height;
export const getCatalogProductsByType = (catalog, type) => catalog.products.filter((product) => type === (product === null || product === void 0 ? void 0 : product.type));
export const findEntityInCatalog = (catalog, entity) => {
    const productRef = getEntityProductRef(entity, true);
    const result = catalog.products.find(({ id }) => {
        return id.includes(productRef);
    });
    if (!result)
        throw new Error(ENTITY_NOT_IN_CATALOG);
    return result;
};
const replaceInsertChildren = (connection, childInNewColor, mountingRailConnectionService, core, color, catalog) => {
    var _a;
    const grandChildren = (_a = connection.guestConnectorEntity.getComponent(ComponentIds.PARENT_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.children;
    grandChildren === null || grandChildren === void 0 ? void 0 : grandChildren.forEach((grandChild) => {
        if (grandChild.hasComponent(COMPONENT_IDS.PROHIBITED_REPLACE_COMPONENT))
            return;
        const grandChildConnection = mountingRailConnectionService.disconnect(grandChild);
        if (!grandChildConnection)
            throw new Error(NO_CONNECTION);
        const grandChildInNewColor = getEntityInColor(core, color, catalog, grandChild);
        if (!grandChildInNewColor)
            return console.warn(ENTITY_DOESNT_EXIST_IN_COLOR);
        return mountingRailConnectionService
            .connect(grandChildInNewColor)
            .to(childInNewColor)
            .atConnector(grandChildConnection.hostConnector.key);
    });
};
export const findProductInColor = (products, productData, color) => {
    const [product, ...newProducts] = products;
    const productColor = product.meta.design;
    const requireMultiColor = productData.meta.color.length > 1;
    const isMultiColor = productColor.length > 1;
    const isRightSize = areOfSameTypeAndSize(product, productData);
    // We require a multicolored variant, and current product is multicolored
    // Find same variant of same design, but different matching brackets.
    if (requireMultiColor && isMultiColor) {
        const primaryColorMatches = productColor === productData.meta.design;
        const secondaryColor = product.meta.color.find((c) => c === color);
        if (primaryColorMatches && secondaryColor && isRightSize)
            return product;
    }
    // We don't require a multicolored variant, find the variant where size
    // matches and provided color matches products design.
    if (!requireMultiColor && isRightSize) {
        const primaryColorMatches = productColor === color;
        if (primaryColorMatches)
            return product;
    }
    if (!newProducts.length)
        throw new Error(`Can't find viable product to replace ${product} in products array.}`);
    return findProductInColor(newProducts, productData, color);
};
export const getEntityInColor = (core, color, catalog, entity) => {
    const entityProduct = findEntityInCatalog(catalog, entity);
    if (!entityProduct.type)
        throw new Error("Product requires a type");
    const insertProducts = getCatalogProductsByType(catalog, entityProduct.type);
    const newProduct = findProductInColor(insertProducts, entityProduct, color);
    return core.services.productManager.createEntity(newProduct.id);
};
export const getUprightsInColor = (core, color, catalog, leftUpright, rightUpright) => {
    return [leftUpright, rightUpright].map((entity) => ({
        oldEntity: entity,
        newEntity: getEntityInColor(core, color, catalog, entity),
    }));
};
const getHostKey = (connection) => connection.hostConnectorKey;
export const recolorSolution = (core, catalog, color, mountingRails) => {
    var _a;
    (_a = core.modules.history()) === null || _a === void 0 ? void 0 : _a.takeSnapshot("change color");
    return mountingRails.map((mountingRail) => {
        const indexedMountingRails = indexMountingRailsInSolution(mountingRail);
        const mountingRailIndexInSolution = getMountingRailIndexInSolution(mountingRail);
        return mountingRailIndexInSolution < 1
            ? handleMostLeftSectionColorChange(core, color, catalog, mountingRail, indexedMountingRails)
            : handleOtherSectionsColorChange(core, color, catalog, mountingRail, indexedMountingRails);
    });
};
const handleOtherSectionsColorChange = (core, color, catalog, selectedMountingRail, indexedMountingRails) => {
    var _a, _b;
    const newMountingRail = getEntityInColor(core, color, catalog, selectedMountingRail);
    if (!newMountingRail)
        return;
    const { leftUpright, rightUpright } = getUprights(selectedMountingRail);
    if (!leftUpright || !rightUpright)
        return;
    const [left, right] = getUprightsInColor(core, color, catalog, leftUpright, rightUpright);
    if (!(left.newEntity && right.newEntity))
        throw new Error(NO_UPRIGHTS);
    const indexOfMountingRail = getMountingRailIndexInSolution(selectedMountingRail);
    const mountingRailToTheLeft = indexedMountingRails[indexOfMountingRail - 1];
    const mountingRailToTheRight = indexedMountingRails[indexOfMountingRail + 1];
    const mountingRailConnectionService = MountingRailConnectionService(core);
    const children = (_a = leftUpright
        .getComponent(ComponentIds.PARENT_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.children.map((child) => {
        return (child.hasComponent(COMPONENT_IDS.INSERT) &&
            mountingRailConnectionService.disconnect(child));
    }).filter((c) => !!c);
    const leftUprightConnection = mountingRailConnectionService.disconnect(leftUpright);
    mountingRailConnectionService.disconnect(selectedMountingRail);
    const rightUprightToMountingRail = mountingRailConnectionService.disconnect(rightUpright);
    if (!leftUprightConnection || !rightUprightToMountingRail)
        throw new Error(NO_CONNECTION);
    mountingRailConnectionService
        .connect(left.newEntity)
        .to(mountingRailToTheLeft)
        .atConnector(getHostKey(leftUprightConnection));
    mountingRailConnectionService
        .connect(newMountingRail)
        .to(left.newEntity)
        .atConnector(MOUNTING_RAIL_TO_UPRIGHT);
    mountingRailConnectionService
        .connect(right.newEntity)
        .to(newMountingRail)
        .atConnector(getHostKey(rightUprightToMountingRail));
    children === null || children === void 0 ? void 0 : children.forEach((connection) => {
        if (!(connection && left.newEntity))
            return;
        const childInNewcolor = getEntityInColor(core, color, catalog, connection.guestConnectorEntity);
        if (!childInNewcolor)
            return;
        mountingRailConnectionService
            .connect(childInNewcolor)
            .to(left.newEntity)
            .atConnector(getHostKey(connection));
        replaceInsertChildren(connection, childInNewcolor, mountingRailConnectionService, core, color, catalog);
    });
    mountingRailToTheRight &&
        mountingRailConnectionService
            .connect(mountingRailToTheRight)
            .to(right.newEntity)
            .atConnector(MOUNTING_RAIL_TO_UPRIGHT);
    const rightChildren = (_b = rightUpright
        .getComponent(ComponentIds.PARENT_COMPONENT_ID)) === null || _b === void 0 ? void 0 : _b.children.map((child) => mountingRailConnectionService.disconnect(child));
    rightChildren === null || rightChildren === void 0 ? void 0 : rightChildren.forEach((connection) => {
        if (!(connection && right.newEntity))
            return;
        mountingRailConnectionService
            .connect(connection.guestConnectorEntity)
            .to(right.newEntity)
            .atConnector(getHostKey(connection));
    });
    [selectedMountingRail, leftUpright, rightUpright].forEach((entity) => entity.dispose());
    return newMountingRail;
};
const handleMostLeftSectionColorChange = (core, color, catalog, selectedMountingRail, indexedMountingRails) => {
    var _a, _b;
    const newMountingRail = getEntityInColor(core, color, catalog, selectedMountingRail);
    if (!newMountingRail)
        return;
    const { leftUpright, rightUpright } = getUprights(selectedMountingRail);
    if (!leftUpright || !rightUpright)
        return;
    const [left, right] = getUprightsInColor(core, color, catalog, leftUpright, rightUpright);
    const indexOfMountingRail = getMountingRailIndexInSolution(selectedMountingRail);
    const mountingRailToTheRight = indexedMountingRails[indexOfMountingRail + 1];
    const mountingRailConnectionService = MountingRailConnectionService(core);
    if (!(left.newEntity && right.newEntity))
        throw new Error(NO_UPRIGHTS);
    const children = (_a = leftUpright
        .getComponent(ComponentIds.PARENT_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.children.map((child) => mountingRailConnectionService.disconnect(child));
    mountingRailToTheRight &&
        mountingRailConnectionService.disconnect(mountingRailToTheRight);
    const leftUprightConnection = mountingRailConnectionService.disconnect(leftUpright);
    const rightUprightConnection = mountingRailConnectionService.disconnect(rightUpright);
    if (!leftUprightConnection || !rightUprightConnection)
        throw new Error(NO_CONNECTION);
    replaceEntity(core, selectedMountingRail, newMountingRail, []);
    mountingRailConnectionService
        .connect(left.newEntity)
        .to(newMountingRail)
        .atConnector(getHostKey(leftUprightConnection));
    mountingRailConnectionService
        .connect(right.newEntity)
        .to(newMountingRail)
        .atConnector(getHostKey(rightUprightConnection));
    mountingRailToTheRight &&
        mountingRailConnectionService
            .connect(mountingRailToTheRight)
            .to(right.newEntity)
            .atConnector(MOUNTING_RAIL_TO_UPRIGHT);
    children === null || children === void 0 ? void 0 : children.forEach((connection) => {
        if (!(connection && left.newEntity))
            return;
        const childInNewcolor = getEntityInColor(core, color, catalog, connection.guestConnectorEntity);
        if (!childInNewcolor)
            return;
        mountingRailConnectionService
            .connect(childInNewcolor)
            .to(left.newEntity)
            .atConnector(getHostKey(connection));
        replaceInsertChildren(connection, childInNewcolor, mountingRailConnectionService, core, color, catalog);
    });
    const rightChildren = (_b = rightUpright
        .getComponent(ComponentIds.PARENT_COMPONENT_ID)) === null || _b === void 0 ? void 0 : _b.children.map((child) => mountingRailConnectionService.disconnect(child));
    rightChildren === null || rightChildren === void 0 ? void 0 : rightChildren.forEach((connection) => {
        if (!(connection && right.newEntity))
            return;
        mountingRailConnectionService
            .connect(connection.guestConnectorEntity)
            .to(right.newEntity)
            .atConnector(getHostKey(connection));
    });
    [selectedMountingRail, leftUpright, rightUpright].forEach((entity) => entity.dispose());
    return newMountingRail;
};
